import React from "react";
import { HomeOutlined } from "@ant-design/icons";
import TopMenu from "themes/cashrent/components/top-menu";
import PageNotFoundIcon from "../assets/svg/page_not_found_icon.svg";
import "./stylesheet.scss";
import { redirectToNewApp } from "../../../utils";

class Index extends React.PureComponent {
  render() {
    return (
      <div>
        <TopMenu/>
        <div className="ui-page-not-found">
          <div>
            <div className="page-not-found-icon">
              <img src={PageNotFoundIcon}/>
            </div>
            <h2>Page not found</h2>
            <div className="ui-page-not-found-desc">The page you are looking for is temporarily unavailable.</div>
            <div className="ui-back-to-home" onClick={() => redirectToNewApp("/app")} >
              <HomeOutlined /> Back to the Homepage
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Index;
